import { eLenderPaid } from '../../../ui-toolkit/enums/eLenderPaid';

const getPrettyLenderPaid = (isZillowClosing: boolean): Record<eLenderPaid, string> => {
  const sendingToText = isZillowClosing ? 'Sending To Zillow Closing' : 'Sending To Spruce';
  return {
    [eLenderPaid.LenderPaidSendingToSpruce]: `Yes - Lender Paid: ${sendingToText}`,
    [eLenderPaid.LenderPaidNotSending]: 'No - Lender Paid: Not Sending',
    [eLenderPaid.TitlePaidNotSending]: 'No - Title Paid: Not Sending',
    [eLenderPaid.OtherNotSending]: 'No - Other: Not Sending',
  };
};

export const lenderPaidOptions = (isZillowClosing: boolean = false): { value: eLenderPaid; label: string }[] => {
  const prettyLenderPaid = getPrettyLenderPaid(isZillowClosing);
  return Object.keys(eLenderPaid).map((k: string) => ({
    value: eLenderPaid[k as eLenderPaid],
    label: prettyLenderPaid[eLenderPaid[k as eLenderPaid]],
  }));
};
